import { useEffect } from "react";

// JSON-LD script'ini <head>'e enjekte eder
export function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `ld-${id}`;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => { const ex = document.getElementById(`ld-${id}`); if (ex) ex.remove(); };
  }, [id, data]);
  return null;
}

export function Meta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
